import { useAtomValue } from 'jotai/utils';
import { featureAvailabilityAtom } from 'src/shared/features/availabilityAtoms';
import { FeatureId, FeatureStatus } from 'src/shared/features/types';

/**
 * Read the runtime availability of a feature. Returns `unknown` until the
 * first probe resolves. See `FeatureAvailabilityProvider` for how the
 * statuses are produced.
 */
export function useFeatureAvailability(id: FeatureId): FeatureStatus {
  const map = useAtomValue(featureAvailabilityAtom);
  return map[id] ?? 'unknown';
}
